import { Fragment, useMemo } from 'react';

import { Column, Row, RowProps } from '../Containers';

import { cn } from 'styles';

import { getID } from 'utils/id';

interface Props {
  className?: string;
  width?: number | string;
  height?: number | string;
  heights?: (string | number)[];
  widths?: (string | number)[];

  circle?: boolean;

  quantity?: number;
  orientation?: 'vertical' | 'horizontal';
  gap?: RowProps['gap'];
  fullWidth?: boolean;
  wrapperClassName?: string;

  wrapMultiple?: boolean;
}

function SingleSkeleton({
  circle,
  className,
  height,
  width,
}: Pick<Props, 'className' | 'height' | 'width' | 'circle'>) {
  return (
    <div
      className={cn(`animate-pulse rounded-md bg-muted`, { 'rounded-full': circle }, className)}
      style={{ width, height }}
    />
  );
}

export function Skeleton({
  height = 32,
  width,
  orientation = 'vertical',
  quantity = 1,
  widths = [],
  heights = [],
  fullWidth,
  gap,
  wrapMultiple = true,
  ...props
}: Props) {
  const id = useMemo(() => getID(), []);

  if (quantity === 1) return <SingleSkeleton height={height} width={width} {...props} />;

  const Wrapper = orientation === 'vertical' ? Column : Row;

  const ActualWrapper = wrapMultiple ? Wrapper : Fragment;

  const hasWidthSet = !!width || !!widths.length;

  return (
    <ActualWrapper gap={gap} fullWidth={hasWidthSet ? fullWidth : true}>
      {Array.from({ length: quantity }).map((_, index) => (
        <SingleSkeleton
          key={`${id}-${index}-skeleton`}
          height={heights[index] ?? height}
          width={widths[index] ?? width ?? '100%'}
          {...props}
        />
      ))}
    </ActualWrapper>
  );
}
